/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ count: NonNullable<unknown> }} Project_Broken_Links_Relink_FailedInputs */



/**
* | output |
* | --- |
* | "{count} source(s) could not be re-linked — you may not have access to them yourself." |
*
* @param {Project_Broken_Links_Relink_FailedInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const project_broken_links_relink_failed = /** @type {((inputs: Project_Broken_Links_Relink_FailedInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Project_Broken_Links_Relink_FailedInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`${i?.count} Quelle(n) konnten nicht neu verknüpft werden — möglicherweise haben Sie selbst keinen Zugriff darauf.`)
	return /** @type {LocalizedString} */ (`${i?.count} source(s) could not be re-linked — you may not have access to them yourself.`)
});